import { SubTitle, Text } from '@appcues/sonar';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';

import { Link } from 'studio5/components';

import { Container, HorizontalRule, SadEmoji } from './ErrorBoundary.styled';

export const STATUS_LINK = 'https://status.appcues.com/';
export const SUPPORT_EMAIL = 'support@appcues.com';

const RouteLevelErrorPage = () => {
  return (
    <Container spacing="small" xAlign="center" yAlign="center">
      <SadEmoji>😔</SadEmoji>
      <SubTitle>We’re sorry, something went wrong on our end.</SubTitle>
      <Text forwardedAs="p" colorToken="color-neutral-700">
        You can try again by refreshing the page. If the problem persists,
        contact us:{' '}
        <Link href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</Link>
      </Text>
      <HorizontalRule />
      <Link href={STATUS_LINK} icon={faExternalLinkAlt} inline>
        Appcues Status
      </Link>
    </Container>
  );
};

export default RouteLevelErrorPage;
